import { render, staticRenderFns } from "./VizModeTable.vue?vue&type=template&id=3dd1bd80&scoped=true&"
import script from "./VizModeTable.vue?vue&type=script&lang=js&"
export * from "./VizModeTable.vue?vue&type=script&lang=js&"
import style0 from "./VizModeTable.vue?vue&type=style&index=0&id=3dd1bd80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd1bd80",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
